/* eslint-disable object-shorthand */
import { Helmet } from 'react-helmet-async';
import { filter, includes, toLower } from 'lodash';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
// components
import { useNavigate } from 'react-router-dom';
import AllVendorServices from '../redux/api/AllVendorServices';
import CustomPopup from '../client/Components/CustomPopup';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import { deleteSelectedVendorMethod, deleteVendorMethod, getAllVendorDetails } from '../redux/slice/allVendorSlice';
import AddVendorForm from '../components/Dialog/AddFormDialog/AddVendorForm';

// ----------------------------------------------------------------------

const statuses = [
  {
    id: 'approved',
    name: 'Approve',
  },
  {
    id: 'rejected',
    name: 'Reject',
  },
];

const blockUnBlock = [
  {
    id: 'unblock',
    name: 'Un Block',
  },
  {
    id: 'blocked',
    name: 'Block',
  },
];

const TABLE_HEAD = [
  { id: 'first_name', label: 'First Name', alignRight: false },
  { id: 'last_name', label: 'Last Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'phone', label: 'Phone No', alignRight: false },
  { id: 'cnic', label: 'CNIC', alignRight: false },
  { id: 'companyName', label: 'Company Name', alignRight: false },
  { id: 'bank_name', label: 'Bank Account Name', alignRight: false },
  { id: 'bank_account_number', label: 'Bank Account No.', alignRight: false },
  { id: 'address', label: 'Address', alignRight: false },
  { id: 'blocked', label: 'User Status', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'payment', label: 'Payment', alignRight: false },

  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = Array.isArray(array) && array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_user) => {
      const lowerQuery = toLower(query);

      return (
        includes(toLower(_user.first_name), lowerQuery) ||
        includes(toLower(_user.last_name), lowerQuery) ||
        includes(toLower(_user.email), lowerQuery) ||
        includes(toLower(_user.phone), lowerQuery) ||
        includes(toLower(_user.cnic), lowerQuery) ||
        includes(toLower(_user.bank_account_number), lowerQuery) ||
        includes(toLower(_user.bank_name), lowerQuery)
      );
    });
  }

  return stabilizedThis.map((el) => el[0]);
}

export default function VendorPage() {
  const data = useSelector((state) => state.vendors);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllVendorDetails());
  }, [dispatch]);

  const navigate = useNavigate();

  const [userId, setUserId] = useState(null);

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [isChangeStatus, setIsChangeStatus] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openAddForm, setOpenAddForm] = useState(false);
  const [isVendorVerified, setIsVendorVerified] = useState();

  const [status, setStatus] = useState();
  const [id, setId] = useState();

  const handleOpenMenu = (event, id) => {
    setUserId(id);
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.data !== null && data.data !== undefined ? data.data.map((n) => n._id) : [];
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const filteredUsers = applySortFilter(
    data.data !== null && data.data !== undefined ? data.data : [],
    getComparator(order, orderBy),
    filterName
  );

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredUsers.length - page * rowsPerPage);

  const isNotFound = !filteredUsers.length && !!filterName;

  const handleChangeRole = async () => {
    await AllVendorServices.vendorRole(id, { status: status })
      .then((results) => {
        if (results.data.success === true) {
          dispatch(getAllVendorDetails());
          setIsChangeStatus(false);
          setStatus();
        }
      })
      .catch((error) => {
        if (!error.response.data.message) {
          toast.error(error.message, { position: 'top-right' });
        } else {
          toast.error(error.response.data.message, { position: 'top-right' });
        }
      });
  };

  const handleSelectDeleteMethod = () => {
    dispatch(deleteSelectedVendorMethod(selected));
    setSelected([]);
  };

  const handleClickOpenAddForm = () => {
    setOpenAddForm(!openAddForm);
  };

  const handleChangeStatus = (id, vendorStatus) => {
    setIsChangeStatus(true);
    setId(id);
    setIsVendorVerified(vendorStatus);
  };
  return (
    <>
      <Helmet>
        <title> Vendors | PakPrint Wishes </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Vendors
          </Typography>
          <Button sx={{ margin: '5px' }} variant="contained" onClick={handleClickOpenAddForm}>
            Add Vendor
          </Button>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            handleSelectDeleteMethod={handleSelectDeleteMethod}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={filteredUsers.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, email, phone, avatarUrl, cnic, address, companyName } = row;
                    const selectedUser = selected.indexOf(_id) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, _id)} />
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={row.first_name} src={avatarUrl} />
                            <Typography variant="subtitle2" noWrap>
                              {!row?.first_name ? 'N/A' : row?.first_name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{!row?.last_name ? 'N/A' : row?.last_name}</TableCell>

                        <TableCell align="left">{!email ? 'N/A' : email}</TableCell>

                        <TableCell align="left">{!phone ? 'N/A' : phone}</TableCell>
                        <TableCell align="left">{!cnic ? 'N/A' : cnic}</TableCell>
                        <TableCell align="left">{!companyName ? 'N/A' : companyName}</TableCell>
                        <TableCell align="left">{!row?.bank_name ? 'N/A' : row?.bank_name}</TableCell>
                        <TableCell align="left">
                          {!row?.bank_account_number ? 'N/A' : row?.bank_account_number}
                        </TableCell>
                        <TableCell align="left">{!address ? 'N/A' : address.slice(0, 24)}</TableCell>

                        <TableCell align="left">
                          <Label
                            color={
                              row.isVendorVerified === 'pending'
                                ? 'warning'
                                : row.isVendorVerified === 'approved' && !row.blocked
                                ? 'success'
                                : 'error'
                            }
                          >
                            {/* {blocked === true ? 'Block' : 'Active'} */}
                            {row.isVendorVerified === 'approved' && !row.blocked
                              ? 'Active'
                              : row.isVendorVerified === 'pending'
                              ? 'Pending'
                              : row.isVendorVerified === 'rejected'
                              ? 'rejected'
                              : 'Block'}
                          </Label>
                        </TableCell>

                        <TableCell align="left">
                          <Button onClick={() => handleChangeStatus(_id, row.isVendorVerified, row.blocked)}>
                            Change
                          </Button>
                        </TableCell>

                        <TableCell align="left">
                          <Button
                            variant="contained"
                            onClick={() => navigate('/dashboard/vendors/payment', { state: { id: row._id } })}
                          >
                            Pay
                          </Button>
                        </TableCell>

                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={(e) => {
                              handleOpenMenu(e, _id);
                            }}
                          >
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            navigate(`/dashboard/vendor-detail/${userId}`);
            setOpen(false);
          }}
        >
          <Iconify icon={'ph:eye'} sx={{ mr: 2 }} />
          View
        </MenuItem>
        <MenuItem
          sx={{ color: 'error.main' }}
          onClick={() => {
            dispatch(deleteVendorMethod(userId));
            setUserId(null);
            setOpen(false);
          }}
        >
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      <AddVendorForm openAddForm={openAddForm} handleClickOpenAddForm={handleClickOpenAddForm} />
      <CustomPopup open={isChangeStatus} setOpen={setIsChangeStatus}>
        <Stack spacing={2} padding={4} sx={{ width: '100%' }}>
          {isVendorVerified === 'approved' ? (
            <>
              <Typography>Select Status to change the current status of vendor</Typography>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  label="Status"
                >
                  {blockUnBlock &&
                    blockUnBlock?.map((item) => (
                      <MenuItem value={item.id} key={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </>
          ) : (
            <>
              <Typography>Select Status to change the current status of user</Typography>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  label="Status"
                >
                  {statuses &&
                    statuses?.map((item) => (
                      <MenuItem value={item.id} key={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </>
          )}

          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={() => handleChangeRole()}>
              Submit
            </Button>
          </Box>
        </Stack>
      </CustomPopup>
    </>
  );
}
